import api from '../services/api';

export interface DesignMaterial {
  id?: number;
  design_no: string;
  design_company_id: number;
  company_id: number;
  material_id: number;
  material?: {
    id: number;
    material_code: string;
    material_type: string;
    material_quality: string;
    quantity: number;
    uom: string;
    rate: number;
    available_qty: number;
    image_url?: string;
  };
  design?: {
    id: number;
    design_no: string;
    name?: string;
    product_type?: string;
    image_url?: string;
  };
  garment_part: string;
  is_sample: boolean;
  allocated_qty: number;
  consumed_qty: number;
  created_at?: string;
  updated_at?: string;
}

export interface CreateDesignMaterialDTO {
  design_no: string;
  design_company_id: number;
  material_id: number;
  garment_part: string;
  is_sample: boolean;
  allocated_qty: number;
}

export interface UpdateDesignMaterialDTO {
  allocated_qty?: number;
  consumed_qty?: number;
  is_sample?: boolean;
  garment_part?: string;
}

const designMaterialsApi = {
  // Get all design materials
  getAll: async () => {
    try {
      const response = await api.get('/design-materials');
      return response.data;
    } catch (error) {
      console.error('Error fetching design materials:', error);
      throw error;
    }
  },

  // Get design materials by design number
  getByDesignNo: async (designNo: string) => {
    try {
      const response = await api.get(`/design-materials/design/${designNo}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching design materials for design ${designNo}:`, error);
      throw error;
    }
  },

  // Get a specific design material by ID
  getById: async (id: number) => {
    try {
      const response = await api.get(`/design-materials/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching design material with ID ${id}:`, error);
      throw error;
    }
  },

  // Create a new design material allocation
  create: async (designMaterial: CreateDesignMaterialDTO) => {
    try {
      const response = await api.post('/design-materials', designMaterial);
      return response.data;
    } catch (error) {
      console.error('Error creating design material allocation:', error);
      throw error;
    }
  },

  // Update a design material allocation
  update: async (id: number, data: UpdateDesignMaterialDTO) => {
    try {
      const response = await api.put(`/design-materials/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating design material allocation with ID ${id}:`, error);
      throw error;
    }
  },

  // Delete a design material allocation
  delete: async (id: number) => {
    try {
      const response = await api.delete(`/design-materials/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting design material allocation with ID ${id}:`, error);
      throw error;
    }
  }
};

export default designMaterialsApi; 